var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input-number',{attrs:{"value":_vm.selfData,"min":_vm.tableData.min,"max":_vm.tableData.max,"size":_vm.tableData.size},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }